// pipe (frontend wave FB): Comms sidebar entry (links to the Notifications feed; the family's
// sub-nav reaches Messages / Send / Preferences / the admin-gated Test event). Cloned from
// records-button.tsx (verbatim shape). Not admin-gated: the server scopes/403s per feed and the
// screens render the localized load-error state.
import { useI18n } from '@affine/i18n';
import { EmailIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const CommsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any `/comms/*` route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/comms');

  return (
    <MenuLinkItem
      icon={<EmailIcon />}
      active={active}
      to={'/comms/notifications'}
    >
      <span data-testid="pipe-comms-nav">
        {t['com.affine.pipe.comms.nav']()}
      </span>
    </MenuLinkItem>
  );
};
